import styled from 'styled-components';
import { AvailableIcon } from '@sainsburys-tech/bolt-icons';
var Icon = styled(AvailableIcon).withConfig({
  displayName: "AvailableIconstyles__Icon",
  componentId: "vmdum1-0"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]);
export { Icon };